import { track as vercelTrack } from "@vercel/analytics";

type EventProperties = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function track(event: string, properties?: EventProperties) {
  vercelTrack(event, properties);

  if (typeof window.gtag === "function") {
    window.gtag("event", event, properties);
  }
}
